import { VESSEL_CATEGORY, VESSEL_STATUS_OF_VESSELS } from "@/config/const";

const _vesselCategory = VESSEL_CATEGORY
const _vesselStatus = VESSEL_STATUS_OF_VESSELS;
const _vesselCategoryOptions = [
  {
    type: _vesselCategory.TANKER,
    name: _vesselCategory.properties["1"].name_ja
  },
  {
    type: _vesselCategory.CARGO,
    name: _vesselCategory.properties["2"].name_ja
  },
  {
    type: _vesselCategory.TUGBOAT,
    name: _vesselCategory.properties["3"].name_ja
  },
  {
    type: _vesselCategory.CRUISE,
    name: _vesselCategory.properties["4"].name_ja
  },
  {
    type: _vesselCategory.FISHING,
    name: _vesselCategory.properties["5"].name_ja
  },
  {
    type: _vesselCategory.PLEASURE,
    name: _vesselCategory.properties["7"].name_ja
  },
  {
    type: _vesselCategory.JET_SKI,
    name: _vesselCategory.properties["8"].name_ja
  },
  {
    type: _vesselCategory.OTHER,
    name: _vesselCategory.properties["9"].name_ja
  },
  {
    type: _vesselCategory.WORK,
    name: _vesselCategory.properties["10"].name_ja
  },
  {
    type: _vesselCategory.SAILBOAT,
    name: _vesselCategory.properties["11"].name_ja
  },
  {
    type: _vesselCategory.BARGE,
    name: _vesselCategory.properties["12"].name_ja
  }
];

const _permissionLevel = {
  READ: 10,
  DELETE: 20,
  EDIT: 30
};

export default {
  data() {
    return {
      vesselCategory: _vesselCategory,
      vesselStatus: _vesselStatus,
      vesselCategoryOptions: _vesselCategoryOptions,
      permissionLevel: _permissionLevel
    };
  },
  methods: {
    getVesselCategoryProps(id) {
      return _vesselCategory.properties[id];
    },
    getVesselCategoryIds() {
      let ids = [];
      Object.keys(_vesselCategory.properties).forEach(key => {
        ids.push(_vesselCategory.properties[key].id);
      });
      return ids.map(item => String(item));
    },
    sizeToLBD(vesselSize) {
      return vesselSize.length_overall;
    }
  }
};
